<template>
    <div class="page">
        <Header/>
        <Nav/>
        <main>
            <router-view/>
        </main>
        <Footer/>
    </div>
</template>

<script>
    import Header from "../components/header/Header";
    import Nav from '../components/nav/Nav'
    import Footer from '../components/footer/Footer'
    export default ({
        components: { Header, Nav, Footer},
    })
</script>

<style lang="less" scoped>
    @media screen and (min-width: 1200px){
        main {
        }
    }
    @media screen and (min-width: 992px) and (max-width: 1200px){
        main {
        }

    }
    @media screen and (min-width: 768px) and (max-width: 992px){
        main {
        }
    }
    @media screen and (max-width: 768px) {
    }
</style>
